import { useNavigate } from 'react-router-dom';
import { useAppStore } from '../store/appStore';
import { getMessageById, formatMessageId, getDirectionLabel, getMessageTypeLabel } from '../utils/secsDataLoader';

export default function Favorites() {
  const navigate = useNavigate();
  const { favorites, toggleFavorite } = useAppStore();

  const favoriteMessages = favorites
    .map(id => getMessageById(id))
    .filter(msg => msg !== null);

  return (
    <div className="max-w-5xl mx-auto p-6">
      <div className="mb-6">
        <h1 className="text-3xl font-bold mb-2">Favorite Messages</h1>
        <p className="text-[var(--color-text-secondary)]">
          {favoriteMessages.length > 0
            ? `You have ${favoriteMessages.length} favorite message${favoriteMessages.length !== 1 ? 's' : ''}`
            : 'No favorite messages yet'}
        </p>
      </div>

      {favoriteMessages.length > 0 ? (
        <div className="space-y-4">
          {favoriteMessages.map((message) => {
            if (!message) return null;

            const messageId = formatMessageId(message.stream, message.function);
            const direction = getDirectionLabel(message.direction);
            const messageType = getMessageTypeLabel(message.messageType);

            return (
              <div key={messageId} className="card p-6">
                <div className="flex items-start justify-between mb-3">
                  <div
                    className="flex-1 cursor-pointer"
                    onClick={() => navigate(`/message/${messageId}`)}
                  >
                    <h2 className="text-xl font-bold mb-1">
                      <span className="font-mono text-primary-600 dark:text-primary-400">
                        {messageId}
                      </span>
                      {' - '}
                      {message.name}
                    </h2>
                    <p className="text-[var(--color-text-secondary)]">
                      {message.description}
                    </p>
                  </div>

                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      toggleFavorite(messageId);
                    }}
                    className="p-2 rounded-lg hover:bg-[var(--color-bg-tertiary)] transition-colors ml-4"
                    title="Remove from favorites"
                  >
                    <svg
                      className="w-5 h-5 fill-yellow-500 stroke-yellow-500"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"
                      />
                    </svg>
                  </button>
                </div>

                <div className="flex flex-wrap gap-2">
                  <span className={`badge ${messageType.color}`}>
                    {messageType.text}
                  </span>
                  <span className={`badge ${direction.color}`}>
                    {direction.text}
                  </span>
                  {message.relatedMessage && (
                    <span className="badge badge-primary">
                      {message.messageType === 'primary' ? 'Reply: ' : 'Primary: '}
                      {message.relatedMessage}
                    </span>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="text-center py-12">
          <svg
            className="mx-auto w-16 h-16 text-[var(--color-text-tertiary)] mb-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"
            />
          </svg>
          <p className="text-[var(--color-text-secondary)] mb-4">
            You haven't added any favorites yet.
          </p>
          <p className="text-sm text-[var(--color-text-tertiary)]">
            Click the star icon on any message to add it to your favorites.
          </p>
        </div>
      )}
    </div>
  );
}
